import { InfoTip } from "@components/tool-tip";
import { AvatarPersonRedux } from "@components/avatar/AvatarPerson";
import React from "react";
import * as ISchema from "@schema";
import {
  EventSchedulingQueryAttendee,
  EventSchedulingQueryOrg,
  EventSchedulingQueryPerson,
} from "./EventScheduling";

const Avatar = ({
  org,
  person,
  tipText,
  calendarId,
  responseStatus,
  size,
}: {
  org: EventSchedulingQueryOrg;
  person: EventSchedulingQueryPerson;
  tipText: JSX.Element | null;
  calendarId: string;
  responseStatus: EventSchedulingQueryAttendee["responseStatus"];
  size?: number;
}) => {
  const profile = person?.profile;

  // TS Validation
  // since `<Avatar />` depends on old ISchema types and its typing cannot be easily changes
  // (because tons of components depend on it)
  // and since we want the Avatar to show empty data as well
  // we coerce `person` into `avatarPerson` a AvatarPersonRedux-type-friendly value.
  const EMPTY_PROFILE: ISchema.IPerson["profile"] = {
    __typename: "UserProfile",
    givenName: "",
    familyName: "",
    externalImageUrl: "",
  };
  const avatarPerson = {
    ...person,
    profile: {
      profile,
      externalImageUrl: profile?.externalImageUrl || EMPTY_PROFILE.externalImageUrl,
      familyName: profile?.familyName || EMPTY_PROFILE.familyName,
      givenName: profile?.givenName || EMPTY_PROFILE.givenName,
      __typename: profile?.__typename || EMPTY_PROFILE.__typename,
    },
  };

  const avatar = (
    <AvatarPersonRedux
      hideUserBadge={true}
      responseStatus={responseStatus ? responseStatus : undefined}
      person={avatarPerson}
      org={org}
      orgPerson={null}
      size={size || 34}
      backupCalendarId={calendarId}
      parentName={"EventScheduling"}
    />
  );

  if (!tipText) {
    return avatar;
  }

  return (
    <div key={calendarId} className="cw-mr-2">
      <InfoTip targetElement={avatar} text={tipText} tipType={"info"} />
    </div>
  );
};

export default Avatar;
